function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');

    if (!this.input) return;

    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );

  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    if (!this.input) return;
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button:not(.localization-selector)').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');

    if(this.mainDetailsToggle.classList.contains('mobile-facets__disclosure')){
    }else{
      this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });

      this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
        submenu.classList.remove('submenu-open');
      });
    }

    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  /*
  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }
  */

  onResize = () => {
    this.header && document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('mobile-menu-nav', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  connectedCallback() {

    // Fix a bug where carousels are sometimes scrolled to the far left on page load
    if( this.dataset.reset_scroll == "true" ) {
      this.slider.scrollLeft = 0;
    }
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();

    document.querySelectorAll('.product-form__input input[type="radio"], .product-form__input select').forEach((option) =>
      option.addEventListener('change', this.whichInputUpdated.bind(option))
    )

    this.addEventListener('change', this.onVariantChange);
  }

  whichInputUpdated(element){

    var optionname = element.target.closest('.product-form__input').querySelector('.form__label').dataset.optionname;

    document.querySelectorAll(`.product-form__input`).forEach((option) =>
      option.classList.remove('activeset')
    );

    document.querySelectorAll(`.form__label[data-optionname="${optionname}"]`).forEach((option) =>
      option.closest('.product-form__input').classList.add('activeset')
    );

  }

  onVariantChange() {

    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }


    var allSelectors = document.querySelectorAll('.section-main-product .product__variant-selector.option-select');

    allSelectors.forEach((selector) => {
      if(selector != this){
        this.updatePairUI(selector, this);
      }
    });


  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {

      const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);

      const inputWrappers = [...this.querySelectorAll('.product-form__input')];

      inputWrappers.forEach((option, index) => {
        if (index === 0) return;
        const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
        const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
        const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
        this.setInputAvailability(optionInputs, availableOptionInputsValue)
      });

  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const destinationSticky = document.getElementById(`price-${this.dataset.section}-support`);

        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (source && destinationSticky) destinationSticky.innerHTML = source.innerHTML;

        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);
        const priceSticky = document.getElementById(`price-${this.dataset.section}-support`);

        if (price) price.classList.remove('visibility-hidden');
        if (priceSticky) priceSticky.classList.remove('visibility-hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);

        this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);

        publish(PUB_SUB_EVENTS.variantChange, {data: {
          sectionId,
          html,
          variant: this.currentVariant
        }});

      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);

    if (!productForm) return;

    const stickyAtcButton = document.getElementById(`sticky-${this.dataset.section}`);

    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > .product-form__submit-text');

    const addButtonSticky = stickyAtcButton?.querySelector('[name="add"]');
    const addButtonTextSticky = stickyAtcButton?.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (addButtonSticky) addButtonSticky.setAttribute('disabled', 'disabled');
      if (text){
        addButtonText.textContent = text;
        if (addButtonSticky) addButtonTextSticky.textContent = text
      };
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;

      if (addButtonSticky){
        addButtonSticky.removeAttribute('disabled');
        addButtonTextSticky.textContent = window.variantStrings.addToCart
      };
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const stickyAtcButton = document.getElementById(`sticky-${this.dataset.section}`);

    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');

    const addButtonSticky = stickyAtcButton?.querySelector('[name="add"]');
    const addButtonTextSticky = stickyAtcButton?.querySelector('[name="add"] > span');

    const price = document.getElementById(`price-${this.dataset.section}`);
    const priceSticky = document.getElementById(`price-${this.dataset.section}-support`);

    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;

    if (addButtonSticky) addButtonTextSticky.textContent = window.variantStrings.unavailable;

    if (price) price.classList.add('visibility-hidden');
    if (priceSticky) priceSticky.classList.add('visibility-hidden');

    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  updatePairUI(paired, original){

    var originalTagName = original.tagName.toLowerCase();
    var pairedTagName = paired.tagName.toLowerCase();
    var originalSelectedItem = '';
    var originalSelectedItemValue = '';

    if(originalTagName.includes("selects")){
      var itemSelect = original.querySelector('.activeset select');
      originalSelectedItem = itemSelect.options[itemSelect.selectedIndex];
      originalSelectedItemValue = originalSelectedItem.value;
    }else{
      originalSelectedItem = original.querySelector('.activeset input[type="radio"]:checked');
      originalSelectedItemValue = originalSelectedItem.value;
    }

    if(pairedTagName.includes("selects")){
      var event = new Event('change');
      paired.querySelector('.activeset select').value = originalSelectedItemValue;
      paired.querySelector(`.activeset option[data-value="${originalSelectedItemValue}"`).click()
      paired.dispatchEvent(event);
    }else{
      paired.querySelector(`.activeset input[type="radio"]:checked`).checked = false;
      var newTarget = paired.querySelector(`.activeset label[data-value="${originalSelectedItemValue}"`).getAttribute('for');
      paired.querySelector(`.activeset input[type="radio"]#${newTarget}`).checked = true;
    }

  }

}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          // Number of cards loaded will be cards.length
          const cards = html.querySelectorAll('.grid__item');

          // When the section is re-loaded with products, liquid within cannot reach the outer feature wrap element
          // Need to add fit-exactly classes with js depending on how many products are loaded
          // With the extra class a width for showing an extra quarter or half overrides the exact fit width
          const feature_card_enabled = this.dataset.feature_card_enabled === 'true';
          if( feature_card_enabled ) {
            const columns_desktop = parseInt(this.dataset.columns_desktop);
            const cards_fit_desktop = cards.length <= columns_desktop;
            const feature_wrap_el = document.querySelector(`#shopify-section-${this.dataset.section_id} .carousel__feature-wrap`);
            if( cards_fit_desktop ) {
              feature_wrap_el.classList.add('carousel__feature-wrap--cards-fit-desktop');
            }
          }

          const parent_section = document.getElementById(this.dataset.section_id);

          // Need to check recently tab before hiding the whole thing
          const hide_recently_tab = this.dataset.hide_recently_tab === 'true';
          const product_handle = this.dataset.product_handle
          const product_handles_list = localStorage.getItem("shopify_recently_viewed");
          const no_recently_viewed = ( !product_handles_list || product_handles_list == "" || product_handles_list == product_handle );

          if (cards) {

            // Loaded
            this.classList.add('product-recommendations--loaded');

          } else if( hide_recently_tab || no_recently_viewed ) {

            // No items - recently not showing - hide the carousel
            if( parent_section ) {
              parent_section.classList.add('hidden');
            }
          } else {
            // hide just product recommendations
            // hide both tabs
            const recommendations = parent_section.querySelector('product-recommendations');
            const recently = parent_section.querySelector('recently-viewed');
            const recommendations_tab = parent_section.querySelector('.product-recommendations-tab');
            const recently_tab = parent_section.querySelector('.recently-viewed-tab');

            recommendations_tab.classList.add('hidden');
            recently_tab.classList.add('hidden');
            recommendations.classList.remove('active');
            recently.classList.add('active');

          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);





class UpsellProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {

          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('upsell-product-recommendations');

          if (recommendations) {
            if(recommendations.innerHTML.trim().length == 0){
              fetch(this.dataset.fallbackurl)
              .then(response => response.text())
              .then(text => {
                html.innerHTML = text;
                const recommendations = html.querySelector('upsell-product-recommendations');
                this.innerHTML = recommendations.innerHTML;
                if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
                  this.remove();
                }
                if (html.querySelector('.grid__item')) {
                  this.classList.add('product-recommendations--loaded');
                }
              });
            }else{
              this.innerHTML = recommendations.innerHTML;
              if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
                this.remove();
              }
              if (html.querySelector('.grid__item')) {
                this.classList.add('product-recommendations--loaded');
              }
            }
          }

        })
        .catch(e => {
          console.error(e);
        });

  }
}

customElements.define('upsell-product-recommendations', UpsellProductRecommendations);


class CrossellProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {

      // check if the PDP has a shop the look section
      const pdpHasShopTheLook = document.querySelector('.shop-the-look-container');
      if (pdpHasShopTheLook) {
        const shopTheLookProductId = item.ProductID;
        if (shopTheLookProductId) {
          this.dataset.url = this.dataset.url.replace(/product_id=[0-9]+/, `product_id=${shopTheLookProductId}`);
        }
      }

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {

          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('crossell-product-recommendations');

          if (recommendations) {
            if(recommendations.innerHTML.trim().length == 0){
              fetch(this.dataset.fallbackurl)
              .then(response => response.text())
              .then(text => {
                html.innerHTML = text;
                const recommendations = html.querySelector('crossel-product-recommendations');
                this.innerHTML = recommendations.innerHTML;
                if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
                  this.remove();
                }
                if (html.querySelector('.grid__item')) {
                  this.classList.add('product-recommendations--loaded');
                }
              });
            }else{
              this.innerHTML = recommendations.innerHTML;
              if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
                this.remove();
              }
              if (html.querySelector('.grid__item')) {
                this.classList.add('product-recommendations--loaded');
              }
            }
          }

        })
        .catch(e => {
          console.error(e);
        });

  }
}

customElements.define('crossell-product-recommendations', CrossellProductRecommendations);


class ShopTheLook extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('shop-look');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item, .slider__slide')) {
            this.classList.add('shop-look--loaded');
          }

          var shopLookGrid = this.querySelector('.shop-the-look-product-grid');
          var shopLookGridChildren = shopLookGrid?.querySelectorAll('.grid__item');

          var shopLookSlider = this.querySelector('shop-look ul.slider');
          var shopLookSliderChildren = shopLookSlider?.querySelectorAll('.grid__item.slider__slide');

          if(shopLookGridChildren?.length > 0 ){
            this.closest('.shop-the-look-container')?.classList.remove('hidden');
          } else {
            this.closest('.shop-the-look-container')?.classList.add('hidden');
          }

          if(shopLookSliderChildren?.length > 0 || Shopify.designMode ){
            this.closest('.carousel')?.classList.remove('hidden');
          }else{
            this.closest('.carousel')?.classList.add('hidden');
          }

        })
        .catch(e => {
          console.error(e);
        });

  }
}

customElements.define('shop-look', ShopTheLook);



class RecentlyViewed extends HTMLElement {
  /*
    data-full_width="{{ full_width }}"
    data-max_cards_to_output="{{ max_cards_to_output }}"
    data-sectionid="{{ section.id }}"
    data-columns_desktop="{{ columns_desktop }}"
    data-columns_mobile="{{ columns_mobile }}"
    data-feature_card_enabled="{{ section.settings.feature_card_enabled }}"
    data-recently_is_only_tab="{{ recently_is_only_tab }}"
    data-on_product_page="{{ on_product_page }}"
  */

  constructor() {

    super();
  }

  config = {
    maxToShow: parseInt(this.dataset.max_cards_to_output),
    minToShow: 1,
    howManyToStoreInMemory: parseInt(this.dataset.max_cards_to_output),
    numberProducts: 0,
    onComplete: null
  };
  productHandleQueue = [];

  cookie = {
    name: 'shopify_recently_viewed',
    write: function (recentlyViewed) {
      localStorage.setItem(this.name, recentlyViewed.join(','));
    },
    read: function () {
      let recentlyViewed = [];
      let cookieValue = localStorage.getItem(this.name);
      if (cookieValue) {
        recentlyViewed = cookieValue.split(',');
      }
      return recentlyViewed;
    },
    destroy: function () {
      localStorage.removeItem(this.name);
    },
    remove: function (productHandle) {
      let recentlyViewed = this.read();
      let position = recentlyViewed.indexOf(productHandle);
      if (position !== -1) {
        recentlyViewed.splice(position, 1);
        this.write(recentlyViewed);
      }
    }
  };

  finalize = () => {

    // Add and remove classes that depend on the number of cards

    // Get elements
    const sliderComponent = this.querySelector('slider-component');
    const sliderUL = this.querySelector('slider-component ul.slider');
    const featureWrap = document.querySelector(`#shopify-section-${this.dataset.section_id}.carousel__feature-wrap`);
    const max_cards_to_output = this.config.maxToShow;

    // Hide buttons if cards fit
    const columns_desktop = parseInt(this.dataset.columns_desktop);
    const columns_mobile = parseInt(this.dataset.columns_mobile);
    let cards_fit_desktop = sliderUL.children.length <= columns_desktop;
    const cards_fit_mobile = sliderUL.children.length <= columns_mobile;
    const feature_card_enabled = parseInt(this.dataset.feature_card_enabled);
    if( feature_card_enabled ) {
      cards_fit_desktop = sliderUL.children.length < columns_desktop;
    }else{
      cards_fit_desktop = sliderUL.children.length <= columns_desktop
    }


    if( cards_fit_desktop ) {
      sliderComponent.classList.add('slider-component--cards-fit-desktop');
    }else{
      sliderComponent.classList.remove('slider-component--cards-fit-desktop');
    }

    if( cards_fit_mobile ) {
      sliderComponent.classList.add('slider-component--cards-fit-mobile');
    }else{
      sliderComponent.classList.remove('slider-component--cards-fit-mobile');
    }

    if( featureWrap ) {
      if( cards_fit_desktop ) {
        featureWrap.classList.add('carousel__feature-wrap--cards-fit-desktop');
      }else{
        featureWrap.classList.remove('carousel__feature-wrap--cards-fit-desktop');
      }
    }

    if( this.dataset.full_width === 'true' ) {

      // set full_width class on parent
      sliderComponent.classList.add('slider-component-full-width');
      sliderComponent.classList.remove('page-width');

      // Add dummy list items for padding
      const li = document.createElement('li');
      li.setAttribute('aria-hidden', 'true');
      li.setAttribute('class', 'slider__slide first-dummy');
      li.innerHTML = '<!--fake padding-->';

      const li_2 = document.createElement('li');
      li_2.setAttribute('aria-hidden', 'true');
      li_2.setAttribute('class', 'slider__slide last-dummy');
      li_2.innerHTML = '<!--fake padding-->';

      sliderUL.prepend(li);
      sliderUL.appendChild(li_2);
    } else {
      sliderComponent.classList.remove('slider-component-full-width');
      sliderComponent.classList.add('page-width');
    }

    sliderUL.scrollLeft = 0;
    this.classList.add('recently-viewed--loaded');

  };

  getRecentProducts = async () => {
    let searchRecentlyUrl;
    let productHandle;

    if (window.location.pathname.indexOf('/products/') !== -1) {
      productHandle = window.location.pathname.match(
        /\/products\/([a-z0-9\-]+)/
      )[1];
      this.productHandleQueue = this.productHandleQueue.filter(handle => productHandle !== handle);
    }

    if (this.productHandleQueue.length < this.config.minToShow) {
      return;
    }
    this.config.numberProducts = this.productHandleQueue.length;

    this.productHandleQueue.length = this.config.maxToShow;
    searchRecentlyUrl = '/search?view=ua_recently-viewed&q=' + this.productHandleQueue.toString();
    await fetch(searchRecentlyUrl).then(response =>
      response.text()
    ).then(html => {
      document.querySelector(`#shopify-section-${ this.dataset.sectionid } recently-viewed`).innerHTML = html;
      this.finalize();
    }).catch(err => {
      console.warn('Something went wrong.', err);
    });

  };

  recordRecentlyViewed = values => {
    let vals = values || {};
    let recentlyViewed = this.cookie.read();
    let productHandle;
    let position;

    // Update defaults.
    this.config = {...this.config, ...vals};

    // If we are on a product page.
    if (window.location.pathname.indexOf('/products/') !== -1) {

      productHandle = window.location.pathname.match(
        /\/products\/([a-z0-9\-]+)/
      )[1];

      position = recentlyViewed.indexOf(productHandle);

      if (position === -1) {

        recentlyViewed.unshift(productHandle);

        recentlyViewed = recentlyViewed.splice(
          0,
          this.config.howManyToStoreInMemory
        );
      } else {

        recentlyViewed.splice(position, 1);
        recentlyViewed.unshift(productHandle);
      }

      this.cookie.write(recentlyViewed);
    }
  }

  showRecentlyViewed = parameters => {

    // Hide whole carousel if only tab and nothing to show
    const recently_is_only_tab = this.dataset.recently_is_only_tab === 'true';
    const sectionid = this.dataset.section_id;
    const carousel = document.querySelector('.carousel.section-'+sectionid);
    const product_handles_list = localStorage.getItem("shopify_recently_viewed");
    if( this.dataset.on_product_page === 'true' ) {
      const product_handle = this.dataset.product_handle;
      const no_recently_viewed = ( !product_handles_list || product_handles_list == "" || product_handles_list == product_handle );
      if( recently_is_only_tab && no_recently_viewed && carousel) {
        carousel.classList.add('hidden');
      } else {
        const no_recently_viewed = ( !product_handles_list || product_handles_list == "" );
        if( recently_is_only_tab && no_recently_viewed && carousel) {
          carousel.classList.add('hidden');
        }
      }
    }


    let params = parameters || {};
    // Update defaults.
    this.config = {...this.config, ...params};

    // Read cookie.
    this.productHandleQueue = this.cookie.read();

    if (this.productHandleQueue === null || this.productHandleQueue === undefined) {
      return false;
    }

    this.config.maxToShow = Math.min(this.productHandleQueue.length, this.config.maxToShow);

    if (this.config.maxToShow) {
      this.getRecentProducts().then();
    }
  }

  connectedCallback() {
    this.showRecentlyViewed();
    this.recordRecentlyViewed();
  }
}

customElements.define('recently-viewed', RecentlyViewed);

class SizeGuideSwitch extends HTMLElement {
  constructor() {
    super();
    this.on = false;
    console.log('SizeGuideSwitch constructor');
  }

  connectedCallback() {

    // Is this the size guide page
    this.sizeGuideTemplate = document.getElementById('template-page-size-guide');
    if( this.sizeGuideTemplate ) {
      // Get rte div that is parent to unit tables on the page
      this.rte = document.querySelector('main .rte');
      this.switch = document.querySelector('size-guide-switch');
      this.heading = document.querySelector('h1');
      this.heading.after(this.switch);
      this.switch.style.opacity = 1;

    }

    // stop variant onchange firing
    this.addEventListener('change', (event) => {
      event.preventDefault();
    });

    this.addEventListener('click', (event) => {
      event.preventDefault();
      if( this.on ) {
        this.classList.add('off');
        this.classList.remove('on');
        this.rte?.classList.add('off');
        this.rte?.classList.remove('on');
      }else{
        this.classList.add('on');
        this.classList.remove('off');
        this.rte?.classList.add('on');
        this.rte?.classList.remove('off');
      }
      this.on = !this.on;
    });
  }
}

customElements.define('size-guide-switch', SizeGuideSwitch);

window.handleize = str => {
  str = str.trim() // remove whitespace from string
  str = str.toLowerCase() // Set to lowercase
  str = str.replace(/\s+/g, '-') // Replace spaces
  str = str.replace(/&/g, '-') // Replace ampersands
  str = str.replace(/----/g, '-') // Replace four dashes
  str = str.replace(/---/g, '-') // Replace triple dashes
  str = str.replace(/--/g, '-') // Replace double dashes
  str = str.replace(/"/g, '') // Removed double quotes
  return str;
}

document.addEventListener("DOMContentLoaded", function () {
    // Function to check for the element and apply changes
    function applyChanges() {
        const blockClass = ".shopify-block.shopify-app-block";
        const shopifyBlock = document.querySelector(blockClass);
        
        if (shopifyBlock) {
            const carouselHeader = document.querySelector(`${blockClass} .CarouselWidget__header.u-textCenter--all`);
            
            if (carouselHeader) {
                carouselHeader.style.cursor = "pointer";
                carouselHeader.addEventListener("click", function () {
                    window.open("https://www.reviews.co.uk/company-reviews/store/kitandkaboodal.com", "_blank"); // Replace with your URL
                });
            } else {
                setTimeout(applyChanges, 500); // Retry after 500ms if element is not found
            }
        } else {
            setTimeout(applyChanges, 500); // Retry after 500ms if container is not found
        }
    }
    
    // Initial delay before executing
    setTimeout(applyChanges, 1000); // Wait 1 second before first attempt
});

/*
Pre-order label fix
*/

(function () {
  const variantInput = document.querySelector('.product-variant-id');
  const submitButton = document.querySelector('.product-form__submit');
  const submitTextEl = submitButton?.querySelector('.product-form__submit-text');

  if (!variantInput || !submitButton || !submitTextEl) return;

  const PREORDER_TEXT = 'Available to Pre-Order';

  // Function to enforce the text if preorder class is present
  const enforcePreorderText = () => {
    if (submitButton.classList.contains('is-preorder-product')) {
      if (submitTextEl.textContent !== PREORDER_TEXT) {
        submitTextEl.textContent = PREORDER_TEXT;
      }
    }
  };

  // Observe text changes to force correct value if needed
  const textObserver = new MutationObserver(() => {
    enforcePreorderText();
  });

  textObserver.observe(submitTextEl, {
    childList: true,
    characterData: true,
    subtree: true
  });

  // Polling in case class changes dynamically (common in Shopify)
  setInterval(() => {
    enforcePreorderText();
  }, 200);
})();




function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}


/*
Notifications overlay click event
*/

document.addEventListener('DOMContentLoaded', function() {
    const trigger = document.getElementById('global-notifications-Overlay');

    if (trigger) {
        trigger.addEventListener('click', function() {
            document.querySelectorAll('.drawer__close-notifications.link').forEach(function(el) {
                el.click();
            });
        });
    }
});

/*
Attentive Private Collection
*/

// Use BEFORE window.__attentive.trigger(...)
function watchAttentivePopup({ onOpen, onClose, openTimeoutMs = 15000 } = {}) {
  const isAttnFrame = (el) =>
    el?.tagName === 'IFRAME' &&
    typeof el.src === 'string' &&
    /(attn\.tv|attentive|attentivecdn)/i.test(el.src);

  const isVisible = (el) => {
    if (!el?.isConnected) return false;
    const rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 && window.getComputedStyle(el).visibility !== 'hidden';
  };

  let state = 'idle'; // 'idle' -> 'opened' -> 'closed'
  let openTimer = null;
  let debouncedCheck = null;

  const nowVisibleAttnIframes = () => Array.from(document.querySelectorAll('iframe')).filter(f => isAttnFrame(f) && isVisible(f));

  const check = () => {
    const visible = nowVisibleAttnIframes();

    if (state === 'idle') {
      if (visible.length) {
        state = 'opened';
        openTimer && clearTimeout(openTimer);
        onOpen && onOpen(visible[0]);
      }
    } else if (state === 'opened') {
      if (!visible.length) {
        state = 'closed';
        observer.disconnect();
        onClose && onClose();
      }
    }
  };

  const scheduleCheck = () => {
    if (debouncedCheck) cancelAnimationFrame(debouncedCheck);
    debouncedCheck = requestAnimationFrame(check);
  };

  const observer = new MutationObserver((mutations) => {
    // Only react to adds/removals/attribute/style changes that might flip visibility
    let relevant = false;
    for (const m of mutations) {
      if (m.type === 'childList') {
        if ([...m.addedNodes, ...m.removedNodes].some(n => n.nodeType === 1 && (n.tagName === 'IFRAME' || n.querySelector?.('iframe')))) {
          relevant = true; break;
        }
      } else if (m.type === 'attributes') {
        if (m.target.tagName === 'IFRAME' || m.target.querySelector?.('iframe')) {
          relevant = true; break;
        }
      }
    }
    if (relevant) scheduleCheck();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'class', 'hidden', 'aria-hidden']
  });

  // Safety: if no visible Attentive iframe appears in time, stop waiting
  openTimer = setTimeout(() => {
    if (state === 'idle') {
      observer.disconnect();
      // silently give up; or log if you prefer
      // console.debug('Attentive popup did not become visible within timeout');
    }
  }, openTimeoutMs);

  // Run an initial check in case it’s already present
  scheduleCheck();

  return () => observer.disconnect(); // optional cleanup
}

// usage
watchAttentivePopup({
  onOpen: () => {
    // console.log('Attentive popup opened');
  },
  onClose: () => {
    console.log('Attentive popup was closed');
    window.location.reload();
    // your post-close logic here
  }
});

/*
******************************************************************
*/

document.addEventListener("DOMContentLoaded", function () {
  const normPath = window.location.pathname.replace(/\/$/, "");
  const CREATIVE_ID = "1212863";
  const CREATIVE_ID_MOBILE = "1241258";
  const BLUR_CLASS = "blur-private-content";

  function waitUntil(checkFn, { interval = 50, timeout = 8000 } = {}) {
    return new Promise((resolve, reject) => {
      const start = Date.now();
      const t = setInterval(() => {
        if (checkFn()) { clearInterval(t); resolve(); }
        else if (Date.now() - start > timeout) { clearInterval(t); reject(new Error("Timeout")); }
      }, interval);
    });
  }

  function safeTrigger(creativeId) {

    return waitUntil(() => window.__attentive && typeof window.__attentive.trigger === "function")
    .then(() => {
      console.log("Attentive ready — showing popup", { creativeId });
      // If trigger returns a promise, returning it keeps the chain intact.
      return window.__attentive.trigger(null, null, null, String(creativeId));
    })
    .catch((err) => {
      console.error("Failed to show popup", err);
    });
  }

  function getCookie(name) {
    const m = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return m ? decodeURIComponent(m[2]) : null;
  }

  function unblurAll() {
    document.querySelectorAll('.' + BLUR_CLASS).forEach(el => el.classList.remove(BLUR_CLASS));
  }

  // If content is injected later (AJAX), keep un-blurring for a short window
  function unblurFor(ms = 1500, every = 100) {
    unblurAll();
    const start = Date.now();
    const i = setInterval(() => {
      unblurAll();
      if (Date.now() - start > ms) clearInterval(i);
    }, every);
  }

  /*
  CHECK IF POPUP CLOSED
  */

  const OVERLAY_ID = "attentive_overlay";
  const RELOAD_FLAG = "attentive_reload_once_test_collection_1";

  function isHidden(el) {
    if (!el) return true;
    // Common “closed” states: display none, visibility hidden, aria-hidden, hidden attribute, etc.
    const style = window.getComputedStyle(el);
    return (
      el.hidden ||
      el.getAttribute("aria-hidden") === "true" ||
      style.display === "none" ||
      style.visibility === "hidden" ||
      style.opacity === "0"
    );
  }

  function watchOverlayClose({ timeout = 30000 } = {}) {
    return new Promise((resolve, reject) => {
      const start = Date.now();

      function tryAttach() {
        const overlay = document.getElementById(OVERLAY_ID);
        if (!overlay) return false;

        // 1) Watch attribute changes that may hide the overlay
        const attrObs = new MutationObserver(() => {
          if (isHidden(overlay)) cleanupAndResolve();
        });
        attrObs.observe(overlay, { attributes: true, attributeFilter: ["style", "class", "aria-hidden", "hidden"] });

        // 2) Watch removal from DOM
        const parent = overlay.parentNode || document.body;
        const removalObs = new MutationObserver(() => {
          if (!document.getElementById(OVERLAY_ID)) cleanupAndResolve();
        });
        removalObs.observe(parent, { childList: true });

        // 3) Also catch explicit close clicks (best-effort; selectors may vary)
        const clickHandler = (e) => {
          const t = e.target;
          if (!t) return;
          // Try common close button patterns (adjust if you know the exact selector)
          if (t.closest('[aria-label="Close"], .close, .attentive-close, button[type="button"]')) {
            // Wait a tick for DOM to update
            setTimeout(() => {
              const stillThere = document.getElementById(OVERLAY_ID);
              if (!stillThere || isHidden(stillThere)) cleanupAndResolve();
            }, 50);
          }
        };
        overlay.addEventListener("click", clickHandler, true);

        function cleanupAndResolve() {
          clearInterval(pollTimer);
          attrObs.disconnect();
          removalObs.disconnect();
          overlay.removeEventListener("click", clickHandler, true);
          resolve();
        }

        return true;
      }

      // Poll briefly until the overlay exists, then attach observers
      const pollTimer = setInterval(() => {
        if (tryAttach()) return;
        if (Date.now() - start > timeout) {
          clearInterval(pollTimer);
          reject(new Error("Overlay never appeared"));
        }
      }, 100);
    });
  }


  /*
  *********************
  */

  if (normPath === "/collections/test-collection-1") {
    var hasCookie = getCookie("attn_creative_source_test-collection-1");

    //if(!hasCookie){
    //  hasCookie = getCookie("attn_creative_source_test-collection-1");
    //}

    if (hasCookie) {
      unblurFor(); // remove from all matching elements (and catch late inserts briefly)
      console.log("cookie exists - access given");
    } else {

      if(window.innerWidth >= 760){
        safeTrigger(CREATIVE_ID);
      }
      else{
        safeTrigger(CREATIVE_ID_MOBILE);
      }

      const creative = (window.innerWidth >= 760) ? CREATIVE_ID : CREATIVE_ID_MOBILE;

      safeTrigger(creative).then(() => {
        // Wait for the user to close the popup (or it disappears)
        return watchOverlayClose().catch(() => null);
      }).then(() => {
        // Prevent reload loops
        if (sessionStorage.getItem(RELOAD_FLAG)) return;

        // Only reload if cookie now exists (optional but recommended)
        const hasCookieNow = getCookie("attn_creative_source_test-collection-1");
        if (!hasCookieNow) return;

        sessionStorage.setItem(RELOAD_FLAG, "1");
        window.location.reload();
      });
      
    }
  }

});

/*
******************
SWATCHES
******************
*/

(function () {

      console.log("swatches ready");

      const SWATCH_UPDATES_CARD_LINK = true; // set to false to disable

      function getCard(el){ return el.closest('product-card') || el.closest('.product-card-wrapper') || document; }
      function setActiveByHandle(card, handle){
        card.querySelectorAll('.card__swatch-item li').forEach(li=>{
          const btn = li.querySelector('[data-product-handle]');
          const on = btn && btn.dataset.productHandle === handle;
          li.classList.toggle('active', on);
          if(btn) btn.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        card.querySelectorAll('.slide').forEach(slide=>{
          slide.toggleAttribute('aria-current', slide.dataset.productHandle === handle);
        });
      }
      function goToIndex(card, index){
        const track = card.querySelector('.product-card-swatch-media-slider .slider-track');
        if(!track) return false;
        track.style.transform = 'translateX(' + (-index * 100) + '%)';
        const slides = Array.from(track.querySelectorAll('.slide'));
        const handle = slides[index] && slides[index].dataset.productHandle;
        if(handle) setActiveByHandle(card, handle);
        return true;
      }
      function goToHandle(card, handle){
        const track = card.querySelector('.product-card-swatch-media-slider .slider-track');
        if(!track) return false;
        const slides = Array.from(track.querySelectorAll('.slide'));
        const idx = slides.findIndex(s => s.dataset.productHandle === handle);
        if(idx < 0) return false;
        return goToIndex(card, idx);
      }
      function updateCardLinks(card, url) {
        if (!SWATCH_UPDATES_CARD_LINK || !url) return;
        // Update any title links inside this card
        card.querySelectorAll('a.full-unstyled-link').forEach(a => {
          a.href = url;
        });
      }
      function initCard(card){
        const track = card.querySelector('.product-card-swatch-media-slider .slider-track');
        if(!track) return;
        const initial = parseInt(track.getAttribute('data-initial-index') || '0', 10);
        goToIndex(card, Math.max(0, initial));
      }

      window.initCard = initCard;

      document.addEventListener('click', function(e){
        const btn = e.target.closest('.card__swatch-item [data-product-handle]');
        if(!btn) return;

        const card = getCard(btn);
        const handle = btn.dataset.productHandle;
        const url = btn.dataset.productUrl;

        const didSlide = goToHandle(card, handle);
        if (didSlide) {
          e.preventDefault();
          updateCardLinks(card, url);
        }
      }, { passive: false });

      //function initAll(root){ (root||document).querySelectorAll('product-card, .product-card-wrapper').forEach(initCard); }
      //window.addEventListener('load', ()=>initAll(document));
      
      /*
      REMOVED
      function initAll(root){
        (root||document).querySelectorAll('product-card, .product-card-wrapper').forEach(initCard);
      }
      */

      /*
      REMOVED
      function boot(){
        initAll(document);
      }
      */

      /*
      REMOVED
      // run ASAP
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', boot, { once: true });
      } else {
        boot();
      }
      */

      // keep these for Shopify editor dynamic sections
      //REMOVED
      //document.addEventListener('shopify:section:load', e => initAll(e.target));      
      
      //document.addEventListener('shopify:section:load', e=>initAll(e.target));

      /* ---------- Custom tooltip for .card__swatch button (reads title) ---------- */

      // Only run tooltips on devices that actually have hover + a fine pointer (mouse/trackpad)
      const canHover = window.matchMedia('(hover: hover)').matches;
      const finePointer = window.matchMedia('(pointer: fine)').matches;

      if (!(canHover && finePointer)) {
        // Touch / coarse pointer device → do nothing (no custom tooltip, no title meddling)
        return;
      }

      // Create tooltip element once
      const tooltip = document.createElement('div');
      tooltip.className = 'custom-tooltip';
      document.body.appendChild(tooltip);

      // Minimal styling (move to your CSS if preferred)
      const style = document.createElement('style');
      style.textContent = `
        .custom-tooltip {
          position: absolute;
          background: #333;
          color: #fff;
          padding: 6px 10px;
          border-radius: 4px;
          font-size: 13px;
          line-height: 1.2;
          white-space: nowrap;
          pointer-events: none;
          opacity: 0;
          transform: translateY(-4px);
          transition: opacity .15s ease, transform .15s ease;
          z-index: 1000;
        }
        .custom-tooltip.show {
          opacity: 1;
          transform: translateY(0);
        }
      `;
      document.head.appendChild(style);

      let currentTooltipTarget = null;

      function showTooltip(text) {
        tooltip.textContent = text;
        tooltip.classList.add('show');
      }
      function moveTooltip(pageX, pageY) {
        // position above cursor with small offset
        const offset = 10;
        tooltip.style.left = (pageX - tooltip.offsetWidth / 2) + 'px';
        tooltip.style.top  = (pageY - tooltip.offsetHeight - offset) + 'px';
      }
      function hideTooltip() {
        tooltip.classList.remove('show');
        tooltip.style.left = '-9999px';
        tooltip.style.top  = '-9999px';
      }

      // Use delegation to handle dynamic DOM
      document.addEventListener('mouseover', (e) => {
        const btn = e.target.closest('.card__swatch button');
        if (!btn || currentTooltipTarget === btn) return;

        const title = btn.getAttribute('title');
        if (!title) return;

        // Prevent native browser tooltip: stash & clear title
        if (!btn.dataset._origTitle) {
          btn.dataset._origTitle = title;
        }
        btn.setAttribute('title', '');

        currentTooltipTarget = btn;
        showTooltip(btn.dataset._origTitle);
        moveTooltip(e.pageX, e.pageY);
      });

      document.addEventListener('mousemove', (e) => {
        if (!currentTooltipTarget) return;
        moveTooltip(e.pageX, e.pageY);
      });

      document.addEventListener('mouseout', (e) => {
        // Hide when leaving the target (and not moving within the same button)
        if (!currentTooltipTarget) return;
        const related = e.relatedTarget;
        if (related && currentTooltipTarget.contains(related)) return;

        // Restore original title for accessibility / long-press
        if (currentTooltipTarget.dataset._origTitle) {
          currentTooltipTarget.setAttribute('title', currentTooltipTarget.dataset._origTitle);
        }
        currentTooltipTarget = null;
        hideTooltip();
      });
      /* ------------------------------------------------------------------------- */
    })();

    function ensureActiveSwatchVisible(card, { smooth = true, align = 'center' } = {}){
      const viewport = card.querySelector('.card__swatch-viewport');
      const list = card.querySelector('.card__swatch-item');
      if (!viewport || !list) return;

      const active = list.querySelector('li.active') || list.querySelector('li');
      if (!active) return;

      const left  = active.offsetLeft;
      const width = active.offsetWidth;

      let target = left; // left-align as base
      if (align === 'center') {
        target = Math.max(0, left - (viewport.clientWidth - width) / 2);
      } else if (align === 'end') {
        target = Math.max(0, left - (viewport.clientWidth - width));
      }

      viewport.scrollTo({ left: target, behavior: smooth ? 'smooth' : 'auto' });
    }


    // Call it when you init each card (alongside your existing initCard)
    (function(){

      /*
      REMOVED
      const origInitAll = (root) => {
        (root||document).querySelectorAll('product-card, .product-card-wrapper').forEach(card => {
          // your existing init
          if (typeof initCard === 'function') initCard(card);
          // nudge swatch into view (safe no-op if nothing is clipped)
          ensureActiveSwatchVisible(card);
        });
      };
      */
      
      /*
      REMOVED
      window.addEventListener('load', () => origInitAll(document));
      document.addEventListener('shopify:section:load', e => origInitAll(e.target));
      */

    })();

    function getSwatchEls(card){
    return {
      viewport: card.querySelector('.card__swatch-viewport'),
      list: card.querySelector('.card__swatch-item'),
      items: card.querySelectorAll('.card__swatch-item > li'),
      btnPrev: card.querySelector('.card__swatch-button--prev'),
      btnNext: card.querySelector('.card__swatch-button--next')
    };
  }

  // Calculate one "page" = how many items fit fully in the viewport.
  function getPageSize(viewport, list, items){
    if (!viewport || !list || !items.length) return 1;
    const first = items[0];
    const styles = getComputedStyle(list);
    const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;

    const itemW = Math.ceil(first.getBoundingClientRect().width);
    const page = Math.max(1, Math.floor((viewport.clientWidth + gap) / (itemW + gap)));
    return page;
  }

  function getFirstFullyVisibleIndex(viewport, items){
    const vLeft = viewport.scrollLeft;
    const vRight = vLeft + viewport.clientWidth;
    for (let i = 0; i < items.length; i++){
      const li = items[i];
      const left = li.offsetLeft;
      const right = left + li.offsetWidth;
      if (left >= vLeft - 1 && right <= vRight + 1) return i;
    }
    // fallback: nearest by left edge
    let idx = 0, best = Infinity;
    for (let i = 0; i < items.length; i++){
      const diff = Math.abs(items[i].offsetLeft - vLeft);
      if (diff < best){ best = diff; idx = i; }
    }
    return idx;
  }

  function scrollToItem(viewport, li){
    if (!viewport || !li) return;
    viewport.scrollTo({ left: li.offsetLeft, behavior: 'smooth' });
  }

  function updateArrowDisabled(card){
  const viewport = card.querySelector('.card__swatch-viewport');
  const list = card.querySelector('.card__swatch-item');
  const btnPrev = card.querySelector('.card__swatch-button--prev');
  const btnNext = card.querySelector('.card__swatch-button--next');
  const nav = card.querySelector('.card__swatch-nav');

  if (!viewport || !list || !nav) return;

  const items = list.querySelectorAll(':scope > li');
  const count = items.length;

  const ALWAYS_NO_OVERFLOW_COUNT =
    window.matchMedia('(max-width: 767px)').matches ? 5 : 7;

  let shouldNoOverflow = false;

  if (count <= ALWAYS_NO_OVERFLOW_COUNT) {
    shouldNoOverflow = true;
  } else {
    const TOLERANCE = 16;

    const prevPadL = viewport.style.paddingLeft;
    const prevPadR = viewport.style.paddingRight;

    viewport.style.paddingLeft = '0px';
    viewport.style.paddingRight = '0px';

    const visibleW = viewport.clientWidth;
    const contentW = list.scrollWidth;

    viewport.style.paddingLeft = prevPadL;
    viewport.style.paddingRight = prevPadR;

    shouldNoOverflow = (contentW - visibleW) <= TOLERANCE;
  }

  nav.classList.toggle('no-overflow', shouldNoOverflow);

  const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
  const hasOverflow = maxScroll > 1;

  const atStart = viewport.scrollLeft <= 0;
  const atEnd   = viewport.scrollLeft >= maxScroll - 1;

  if (btnPrev) {
    btnPrev.style.display = atStart ? 'none' : '';
    btnPrev.disabled = shouldNoOverflow || !hasOverflow || atStart;
  }

  if (btnNext) {
    btnNext.style.display = (shouldNoOverflow || !hasOverflow) ? 'none' : '';
    btnNext.disabled = shouldNoOverflow || !hasOverflow || atEnd;
  }
}




  function pageBy(card, dir){
    const { viewport, list, items, btnPrev, btnNext } = getSwatchEls(card);
    if (!viewport || !list || !items.length) return;

    /*{% comment %} const page = getPageSize(viewport, list, items); {% endcomment %}*/
    const firstVisible = getFirstFullyVisibleIndex(viewport, items);
    /*{% comment %} const targetIndex = Math.min(Math.max(0, firstVisible + dir * page),Math.max(0, items.length - 1)); {% endcomment %}*/
     const targetIndex = Math.min(Math.max(0, firstVisible + dir * 1), items.length - 1);

    scrollToItem(viewport, items[targetIndex]);

    // give it a moment, then update disabled states
    setTimeout(() => updateArrowDisabled(card), 180);
  }

  function initSwatchCarousel(card){
    const viewport = card.querySelector('.card__swatch-viewport');
    const btnPrev = card.querySelector('.card__swatch-button--prev');
    const btnNext = card.querySelector('.card__swatch-button--next');
    const nav = card.querySelector('.card__swatch-nav');
    if (!viewport) return;

    if (btnPrev && !btnPrev.dataset._swatchBound) {
      btnPrev.dataset._swatchBound = '1';
      btnPrev.addEventListener('click', (e)=>{ e.preventDefault(); pageBy(card, -1); }, { passive: false });
    }
    if (btnNext && !btnNext.dataset._swatchBound) {
      btnNext.dataset._swatchBound = '1';
      btnNext.addEventListener('click', (e)=>{ e.preventDefault(); pageBy(card, +1); }, { passive: false });
    }

    // Run now, then after layout settles
    updateArrowDisabled(card);
    requestAnimationFrame(() => updateArrowDisabled(card));
    setTimeout(() => updateArrowDisabled(card), 250);
    setTimeout(() => updateArrowDisabled(card), 1000);

    // Observe size changes (nav/card changes are what you care about)
    const ro = new ResizeObserver(() => updateArrowDisabled(card));
    if (nav) ro.observe(nav);
    ro.observe(viewport);

    viewport.addEventListener('scroll', () => updateArrowDisabled(card), { passive: true });
  }



  // Keep active in view after swatch click (re-using your existing click handler)
  document.addEventListener('click', function(e){
    const btn = e.target.closest('.card__swatch-item [data-product-handle]');
    if (!btn) return;
    const card = btn.closest('product-card, .product-card-wrapper') || document;

    // defer so your setActiveByHandle has run
    setTimeout(() => ensureActiveSwatchVisible(card, { smooth: true, align: 'center' }), 0);
  });

  document.addEventListener('click', (e) => {
    const next = e.target.closest('.card__swatch-button--next');
    const prev = e.target.closest('.card__swatch-button--prev');
    if (!next && !prev) return;

    e.preventDefault();

    const card = (next || prev).closest('product-card, .product-card-wrapper') || document;
    pageBy(card, next ? +1 : -1);
  }, { passive: false });


  /*
  REMOVED

  // Hook into your existing initAll flow
  function initAllSwatchCarousels(root){
    (root || document).querySelectorAll('product-card, .product-card-wrapper')
      .forEach(initSwatchCarousel);
  }

  window.addEventListener('load',   () => initAllSwatchCarousels(document));
  document.addEventListener('shopify:section:load', e => initAllSwatchCarousels(e.target));
  */


/*
SWATCHES INIT (robust for filters + recommendations)
*/

function runWhenMeasurable(card, fn, { tries = 12, delay = 120 } = {}) {
  let n = 0;
  const tick = () => {
    const viewport = card.querySelector('.card__swatch-viewport');
    if (viewport && viewport.clientWidth > 0) { fn(); return; }
    if (++n >= tries) return;
    setTimeout(tick, delay);
  };
  tick();
}

function initProductCard(card){
  if (typeof initSwatchCarousel === 'function') {
    initSwatchCarousel(card);
  }

  if (typeof window.initCard === 'function') {
    window.initCard(card);
  }

  runWhenMeasurable(card, () => {
    ensureActiveSwatchVisible(card, { smooth:false, align:'center' });
    updateArrowDisabled(card);
  });
}

function initCardsIn(root){
  (root || document)
    .querySelectorAll('product-card, .product-card-wrapper')
    .forEach(initProductCard);
}

// Initial run
initCardsIn(document);

// Observe BODY so grid replacement doesn’t kill it
const mo = new MutationObserver((mutations) => {
  for (const m of mutations) {
    for (const node of m.addedNodes) {
      if (!(node instanceof Element)) continue;
      if (
        node.matches?.('product-card, .product-card-wrapper') ||
        node.querySelector?.('product-card, .product-card-wrapper')
      ) {
        requestAnimationFrame(() => initCardsIn(node));
      }
    }
  }
});

mo.observe(document.body, { childList:true, subtree:true });

// Late layout safety
window.addEventListener('load', () => initCardsIn(document));
